module.exports = __webpack_public_path__ + "static/media/YF16_2.08d820d2.jpg";